<template>
    <div
        class="d-inline-flex justify-content-start align-items-center vh-100 w-100"
    >
        <!-- <div class="mh-100">
            <img src="/images/login-side-image.png" class="img-fluid object-cover vh-100" />
        </div> -->

        <div class="login-form">
            <div class="text-center">
                <img
                    id="logo"
                    src="/images/logo-st-engineering.png"
                    class="mb-5"
                />
            </div>

            <h1 class="font-weight-bold mt-5">Sign In</h1>

            <div class="text-identity mb-5" style="color: #289983">
                Sign in if you have an account
            </div>

            <form @submit.prevent="form.post('/login')">
                <div class="mb-4">
                    <div class="mb-3">Your email</div>
                    <input
                        type="email"
                        v-model="form.email"
                        name="email"
                        class="rounded-pill p-4 border-light form-control"
                        :class="{ 'is-invalid': form.errors.email }"
                        placeholder="Enter Email Address"
                    />
                    <div v-if="form.errors.email" class="error mt-1">
                        {{ form.errors.email }}
                    </div>
                </div>

                <div class="mb-2">
                    <div class="mb-3">Password</div>
                    <input
                        type="password"
                        v-model="form.password"
                        name="password"
                        class="rounded-pill p-4 border-light form-control input-password"
                        :class="{ 'is-invalid': form.errors.password }"
                        placeholder="Enter Password"
						@input="checkPasswordStrength(form.password)"
                    />
					<div v-if="passwordStrength.strength" class="m-1 pl-3 py-2 text-white mt-3" style="background-color:#E9E5E5;">
						<p class="text-dark"><b>Password must include :</b></p>
						<span :class="{ 'text-success': passwordValidation.passwordLength, 'text-danger': !passwordValidation.passwordLength }">
							<b>
								<i v-if="passwordValidation.passwordLength" :class="{ 'text-success': passwordValidation.passwordLength, 'text-danger': !passwordValidation.passwordLength }" class="fa-solid fa-check text-identity mr-2 title-icon"></i>
								<i v-else :class="{ 'text-success': passwordValidation.passwordLength, 'text-danger': !passwordValidation.passwordLength }" class="fa-solid fa-close text-identity mr-2 title-icon"></i>
								Minimum 12 Characters
							</b>
						</span><br>
						<span :class="{ 'text-success': passwordValidation.hasUppercase, 'text-danger': !passwordValidation.hasUppercase }">
							<b>
								<i v-if="passwordValidation.hasUppercase" :class="{ 'text-success': passwordValidation.hasUppercase, 'text-danger': !passwordValidation.hasUppercase }" class="fa-solid fa-check text-identity mr-2 title-icon"></i>
								<i v-else :class="{ 'text-success': passwordValidation.hasUppercase, 'text-danger': !passwordValidation.hasUppercase }" class="fa-solid fa-close text-identity mr-2 title-icon"></i>
								At least one capital letter
							</b>
						</span><br>
						<span :class="{ 'text-success': passwordValidation.hasNumber, 'text-danger': !passwordValidation.hasNumber }">
							<b>
								<i v-if="passwordValidation.hasNumber" :class="{ 'text-success': passwordValidation.hasNumber, 'text-danger': !passwordValidation.hasNumber }" class="fa-solid fa-check text-identity mr-2 title-icon"></i>
								<i v-else :class="{ 'text-success': passwordValidation.hasNumber, 'text-danger': !passwordValidation.hasNumber }" class="fa-solid fa-close text-identity mr-2 title-icon"></i>
								At least one number
							</b>
						</span><br>
						<span :class="{ 'text-success': passwordValidation.noSpace, 'text-danger': !passwordValidation.noSpace }">
							<b>
								<i v-if="passwordValidation.noSpace" :class="{ 'text-success': passwordValidation.noSpace, 'text-danger': !passwordValidation.noSpace }" class="fa-solid fa-check text-identity mr-2 title-icon"></i>
								<i v-else :class="{ 'text-success': passwordValidation.noSpace, 'text-danger': !passwordValidation.noSpace }" class="fa-solid fa-close text-identity mr-2 title-icon"></i>
								No spaces
							</b>
						</span><br>
						<!-- {{passwordStrength.strength}} -->
					</div>
                    <!-- <div  class="m-1 pl-3 py-2 text-white mt-3" style="background-color:#E9E5E5;">
						<span class="text-danger">
							<b>
								Your password has expired, please click forget password link to set a new password
							</b>
						</span>
					</div> -->
                    <div v-if="form.errors.password" class="error mt-1">
                        {{ form.errors.password }}
                    </div>
                </div>

                <div class="small w-100 text-right mb-5">
                    <Link class="text-grey" href="/forgot-password"
                        >Forget password?</Link
                    >
                </div>

                <div class="text-center mt-3">
                    <button
                        class="btn btn-alt btn-create px-5"
                        type="submit"
                        :disabled="form.processing || passwordStrength.strength != 'Strong'"
                    >
                        Sign in
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    layout: null,
    props: {
        title: String,
    },
    watch: {
        title: {
            immediate: true,
            handler(title) {
                document.title = `${title} - Synthesis`;
            },
        },
    },
    data() {
        return {
			password: '',
		    passwordStrength: {
		      score: 0,
		      strength: '',
		    },
			passwordValidation: {
				passwordLength: false,
				hasUppercase: false,
				hasNumber: false,
				noSpace: true
			},
            form: this.$inertia.form({
                email: null,
                password: null,
            }),
        };
    },
    updated() {
        if (this.$page.props.errors.email.match(/Too many login attempts.*/)) {
            location.replace("/locked");
        }
    },
	methods: {
		checkPasswordStrength(password) {
			let score = 0;

			const hasUpperCase = /[A-Z]/.test(password);
			const hasLowerCase = /[a-z]/.test(password);
			const hasNumber = /[0-9]/.test(password);
			const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);
			const hasSpace = password.includes(" ");

			if (password.length >= 12) {
				score++;
				this.passwordValidation.passwordLength= true;
			} else {
				this.passwordValidation.passwordLength= false;
			}

			if (hasUpperCase) {
				score++;
				this.passwordValidation.hasUppercase = true;
			} else {
				this.passwordValidation.hasUppercase = false;
			}

			if (hasNumber) {
				score++;
				this.passwordValidation.hasNumber = true;
			} else {
				this.passwordValidation.hasNumber = false;
			}

			if (hasSpace) {
				this.passwordValidation.noSpace = false;
			} else {
				score++;
				this.passwordValidation.noSpace = true;
			}

			let strength = "";
			if (score <= 1) {
				strength = 'Weak';
			} else if (score == 2 || score == 3) {
				strength = 'Medium';
			} else if (score > 3) {
				strength = 'Strong';
			}

			this.passwordStrength.score = score;
			this.passwordStrength.strength = strength;

			return this.passwordStrength;
		},
    },
};
</script>
